import { trpc } from '@/shared/api';

/** 고객 에디터 진입용 최신 공개 편집영역(editor.editAreas.getLatestPublic). 미공개·없음은 NOT_FOUND 로 온다. */
export const useLatestPublicEditAreaQuery = (productId: string) =>
  trpc.editor.editAreas.getLatestPublic.useQuery(
    { productId },
    { enabled: productId.length > 0, retry: false },
  );
